<template>
  <AnalyticsCard
    title="When people browse"
    :subtitle="`Visits by hour, in ${zoneLabel}`"
    :loading="loading"
    :empty="!loading && isEmpty"
    empty-title="No visits in this period"
    empty-hint="Compare this against when you actually get booked. The gap is the case for opening different slots."
    :height="240"
  >
    <div ref="el" class="w-full h-56"></div>
  </AnalyticsCard>
</template>

<script setup>
import { computed, toRef } from 'vue'
import AnalyticsCard from '../shared/AnalyticsCard.vue'
import { useAnalyticsChart, baseOptions, PALETTE } from '../shared/useAnalyticsChart.js'

const props = defineProps({
  data:    { type: Array, default: () => [] },
  zone:    { type: String, default: '' },
  loading: { type: Boolean, default: false },
})

const isEmpty = computed(() => props.data.every(d => !d.visitors))
const zoneLabel = computed(() => (props.zone || 'your timezone').replace(/_/g, ' '))

function hourLabel(hour) {
  if (hour === 0) return '12am'
  if (hour === 12) return '12pm'
  return hour < 12 ? `${hour}am` : `${hour - 12}pm`
}

const { el } = useAnalyticsChart((_node, tokens) => {
  if (!props.data.length) return null
  const base = baseOptions(tokens)

  return {
    ...base,
    chart: { ...base.chart, type: 'column', height: 224, spacing: [16, 16, 8, 4] },
    xAxis: {
      ...base.xAxis,
      categories: props.data.map(d => hourLabel(d.hour)),
      // Every fourth label. Twenty-four across this width is unreadable.
      tickInterval: 4,
      crosshair: { color: tokens.grid },
    },
    yAxis: { ...base.yAxis, min: 0, allowDecimals: false },
    tooltip: { ...base.tooltip, headerFormat: '', pointFormat: '<b>{point.category}</b><br>{point.y} visitors' },
    plotOptions: { column: { borderWidth: 0, borderRadius: 3, pointPadding: 0.05, groupPadding: 0.08, color: PALETTE.cyan } },
    series: [{ name: 'Visitors', data: props.data.map(d => d.visitors) }],
  }
}, [toRef(props, 'data')])
</script>
